import { render } from "./VacancyTabItems.vue?vue&type=template&id=5f2daed4"
import script from "./VacancyTabItems.vue?vue&type=script&lang=js"
export * from "./VacancyTabItems.vue?vue&type=script&lang=js"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__